<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fak"
			data-icon="filter-icon"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 640 512"
			class="fa-filter-icon"
		>
			<path
				fill="currentColor"
				d="M202.524 0h9.956c8.248 0 14.933 6.612 14.933 14.77v191.015a14.61 14.61 0 01-.731 4.579c52.442 8.992 92.322 54.215 92.322 108.651 0 54.438-39.88 99.66-92.322 108.652.475 1.44.731 2.98.731 4.58v64.985c0 8.157-6.685 14.768-14.933 14.768h-9.956c-8.247 0-14.933-6.611-14.933-14.768v-64.986c0-1.6.257-3.139.732-4.579C135.88 418.675 96 373.453 96 319.015c0-54.436 39.881-99.66 92.323-108.651a14.612 14.612 0 01-.732-4.58V14.77C187.591 6.612 194.277 0 202.524 0zm4.978 238.277c-45.086 0-81.635 36.148-81.635 80.738 0 44.591 36.549 80.739 81.635 80.739 45.086 0 81.636-36.148 81.636-80.739 0-44.59-36.55-80.738-81.636-80.738zM482.275 79.754c0 1.598-.256 3.137-.733 4.579 52.445 8.991 92.324 54.215 92.324 108.652 0 54.436-39.879 99.66-92.324 108.651.477 1.442.733 2.981.733 4.58v191.016c0 8.157-6.685 14.768-14.934 14.768h-9.955c-8.247 0-14.932-6.611-14.932-14.768V306.215c0-1.598.256-3.137.73-4.579-52.442-8.992-92.323-54.215-92.323-108.651 0-54.437 39.881-99.66 92.323-108.652a14.648 14.648 0 01-.73-4.58V14.77C442.454 6.612 449.14 0 457.386 0h9.955c8.25 0 14.934 6.612 14.934 14.77v64.984zm-19.91 193.97c45.085 0 81.635-36.149 81.635-80.74 0-44.59-36.55-80.738-81.635-80.738-45.088 0-81.635 36.148-81.635 80.739 0 44.59 36.547 80.738 81.635 80.738z"
				class="light"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'FilterIcon',
	components: { Icon },
	props,
}
</script>
